var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "478.306 236.726 12 20",
    width: 12,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 488.31 236.726 L 480.302 236.726 C 479.199 236.726 478.306 237.62 478.306 238.722 L 478.306 254.729 C 478.306 255.832 479.2 256.726 480.302 256.726 L 488.309 256.726 C 489.411 256.726 490.305 255.833 490.306 254.73 L 490.306 238.722 C 490.306 237.62 489.412 236.726 488.31 236.726 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 488.306 252.726 L 480.306 252.726 L 480.306 238.726 L 488.306 238.726 L 488.306 252.726 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 484.306 255.726 C 483.616 255.726 483.056 255.279 483.056 254.726 C 483.056 254.173 483.616 253.726 484.306 253.726 C 484.996 253.726 485.556 254.173 485.556 254.726 C 485.556 255.279 484.996 255.726 484.306 255.726 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4d9dddb0.svg";
export { ForwardRef as ReactComponent };